<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn icon dark title="Back to payroll cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-adustments" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <b>Select cutoff period</b>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?header_mobile:header"
                    :items="cutoff_periods_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr class="clickable" @click="viewDetails(props.item)">
                            <td v-if="isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                    {{ props.item.cutOffStart | moment("MMM DD") }} - {{ props.item.cutOffEnd | moment("DD, YYYY") }}
                                </span>
                            </td>
                            <td v-if="!isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                <span :class="commonfn.getStatusColorByDesc(props.item.payrollOverallStatus)">{{props.item.payrollOverallStatus}}</span>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-layout> 
</template>

<script>

import manualAdjustmentsApi from '@/api/manualadjustments'
import commonfn from '@/common/functions'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, getCalendarYear, getSearchKeyword, updateCalendarYear, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'

export default {     
    name: 'Adjustments',
    metaInfo: {
        title: 'Adjustments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Manual Adjustments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            selectedFiscalYear: getCalendarYear(this.$route.name),
            search: getSearchKeyword(routeName),
            header: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '20%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutoffStart', width: '20%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutoffEnd', width: '20%', sortable:true},
                {text: 'CutOff Status',align: 'left',value: 'status',  width: '20%', sortable:true},
                {text: 'Payroll Status',align: 'left',value: 'payrollOverallStatus',  width: '20%', sortable:true},
            ],
            header_mobile: [
                {text: 'Period',align: 'left',value: 'cutOffStart', width: '40%', sortable:true},
                {text: 'Cutoff',align: 'left',value: 'cutOffStatus',  width: '30%', sortable:true},
                {text: 'Payroll',align: 'left',value: 'payrollOverallStatus',  width: '30%', sortable:true},
            ],
            x:null,
            y:null,
            mode:null,
            error: false,
            errorMessage: '',
            loading: false,
            snackbar: false,
            snackbarText: '',
            cutoff_periods: [],
            serverDate: null,
            company_details: null,            
            menu_status: false,
        }
    },
    methods: {
        isCurrentPeriod(data){
            return data.cutOffPeriodDesc == 'Current'
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            updateCalendarYear(this.$route.name, fiscalYear)
        },
        viewDetails(data) {
            //allow to edit during Frozen cutoff period since payroll adjustments will 
            //be done during payroll processing and adjustment still need approval
            if (data.cutOffStatus == commonfn.getStatusCode('Closed')) {
                this.snackbar = true
                this.snackbarText = `Selected Cutoff period is already ${commonfn.getStatusDescription(data.cutOffStatus)}.`
                return
            }
            this.$router.push(`/payroll/adjustments/summary/${data.cutOffId}`)
        },
        async getSummary() {
            try {
                this.loading = true
                const response = await manualAdjustmentsApi.getSummary()
                if (response && response.status == 200) {
                    this.cutoff_periods = response.data.cutoffItems
                    this.company_details = response.data.company
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Adjustments'
        })

        this.getSummary()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        cutoff_periods_filtered() {
            let temp = this.cutoff_periods.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return this.$moment(item.cutOffStart).format('YYYY-MM-DD').includes(this.search) ||
                        this.$moment(item.cutOffEnd).format('YYYY-MM-DD').includes(this.search)
                })
            }
            return temp //.reverse()
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
    }
}
</script>